import Vue from 'vue'
import VueMq from 'vue-mq'

Vue.use(VueMq, {
  breakpoints: {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1300
  }
})


// WEBPACK FOOTER //
// ./resources/js/plugins/media-query.js